import ConnectedDomainSearchHero from './ConnectedDomainSearchHero';

export default ConnectedDomainSearchHero;
